import { FacilityPlugs, StatsPanels, StatsTabs } from "slot-definitions"
import { Link, Tab } from "@mui/material"
import { TabPanel } from "@mui/lab"
import { useBoundContext } from "lib/@components/binding/use-bound-context"
import { Profile } from "routes/facilities/plugins/maintenance-profile-tab/profile"
import { registerTab } from "lib/@components/tabs"
import { REGIME_ASSETS_TAB } from "routes/asset-register/plugins/regime-display/regime-display.runtime"
import { isEnabled } from "lib/@components/feature"
import { FEATURE_FLAG_ASSET_MAPPING_OVERVIEW } from "routes/asset-register/feature-flag-asset-mapping"
import { useSearchParam } from "lib/@hooks/use-search-param"
import {
    getFacilityProfileNavigatorRoute,
    getFacilityProfileScheduleRoute,
} from "routes/facilities/plugins/maintenance-profile-tab/facility-profile-routes"

FacilityPlugs.plug(<MaintenanceProfileTab />)

function MaintenanceProfileTab() {
    const context = useBoundContext()
    const [share] = useSearchParam("share", null)
    context.LinkComponent = MyLink
    context.scheduleProfileRoute = getScheduleRoute
    context.regimeNavigatorRoute = getNavigatorRoute
    StatsTabs.usePlug(<Tab value="Profile" label="Profile" />)
    StatsPanels.usePlug(
        <TabPanel value="Profile">
            <Profile $lazy />
        </TabPanel>
    )
    return null

    function getScheduleRoute({ stats, schedule }) {
        return getFacilityProfileScheduleRoute({ stats, schedule, share })
    }

    function getNavigatorRoute(item) {
        return getFacilityProfileNavigatorRoute({ item, share })
    }
}

function MyLink({ children, sx, ...props }) {
    const linkSx = [{ fontSize: 13 }, sx].filter(Boolean)

    return (
        <Link {...props} sx={linkSx}>
            {children}
        </Link>
    )
}

registerTab({
    tab: REGIME_ASSETS_TAB,
    id: "profile",
    title: "Overview",
    predicate: () => isEnabled(FEATURE_FLAG_ASSET_MAPPING_OVERVIEW),
    content: <Profile $lazy priority={140} />,
})
